export default "__VITE_ASSET__CTtKgr81__"